import ConfirmDialog, {ConfirmDialogProps, ControlState} from '@/components/ConfirmDialog.tsx';
import {InputGroup} from '@blueprintjs/core';
import {ChangeEventHandler, ReactElement, useCallback, useState} from 'react';

export type ConfirmFn = () => Promise<void>;

interface Props extends ConfirmDialogProps {
	confirmText: string,
	onConfirm: ConfirmFn,
}

export default function ConfirmDeleteDialog({onConfirm, confirmText, ...props}: Props): ReactElement {
	const [processing, setProcessing] = useState(false);
	const [confirmation, setConfirmation] = useState('');

	const onConfirmationChange: ChangeEventHandler<HTMLInputElement> = useCallback(event => {
		setConfirmation(event.currentTarget.value);
	}, []);

	const onConfirmInternal = useCallback(async () => {
		if (processing)
			return;

		setProcessing(true);
		await onConfirm();
		setProcessing(false);
	}, [onConfirm, processing]);

	let controlState = ControlState.Normal;

	if (processing)
		controlState = ControlState.Loading;
	else if (confirmation !== confirmText)
		controlState = ControlState.Disabled;

	return (
		<ConfirmDialog onConfirm={onConfirmInternal} controlState={controlState} {...props}>
			<p>
				Are you sure you want to delete {confirmText}? This action cannot be undone.
			</p>

			<p>
				To confirm, type <strong>{confirmText}</strong> in the box below, then press "Confirm."
			</p>

			<InputGroup onChange={onConfirmationChange} value={confirmation} />
		</ConfirmDialog>
	);
}
